module.exports = __webpack_public_path__ + "img/2f_l_yanagi@2x.d20667f7.jpg";